<template>
  <div :title="$t('sectionModalPerson.clickToEditContactData')">
    <button class="btn btn-secondary" @click="AbrirModal()">
      {{ nome }}
    </button>
    <b-modal
      v-model="abrir"
      :title="$t('sectionModalPerson.contact')"
      size="sm"
      hide-footer
    >
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <form v-else @submit="ValidarForm">
        <div class="row" v-if="viewModel.nome =='' || viewModel.numeroTelefone ==''">
          <div class="col">
            <div class="form-group">
              <small>{{ $t("textObrigatorios") }}</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="contato_profile">
              <!-- <ProfilePictureVue :customerName="image || viewModel.nome " /> -->
              <ProfilePictureVue 
                v-if="viewModel.urlPerfil != 'x' "  
                  :profilePicturePath="viewModel.urlPerfil" :tipoConversa="viewModel.enumTipoContato" /> 
                    
              <ProfilePictureVue v-else-if="viewModel.urlPerfil == 'x'" :customerName="image || viewModel.nome" :tipoConversa="viewModel.enumTipoContato" /> 


            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>* {{ $t("sectionOrcamento.orcamentoNome") }}</label>
              <input
                v-model="viewModel.nome"
                type="text"
                class="form-control"
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label v-if="enumTipoContato == 0">* {{ $t("sectionOrcamento.orcamentoTelefone") }} </label>
              <label v-else>* {{ $t("sectionOrcamento.orcamentoIdentificador") }} </label>
              <input
                v-model="viewModel.numeroTelefone"
                type="tel"
                class="form-control"
                :placeholder="$t('sectionOrcamento.orcamentoTelefone')"
                disabled
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for>{{ $t("sectionPessoa.pessoaStatusAtivo") }}</label>
              <b-form-checkbox
              v-model="viewModel.ativo"
              name="check-button"
              switch
              >
              {{ $t("textYes") }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <button class="btn btn-success" type="submit">
             {{ $t("btSalvar") }}
            </button>
          </div>
          <div class="col">
              <a
                :href="'#/pessoa/contato/' + contatoId + '/' + enumTipoContato"
                target="_blank"
                :title="$t('sectionModalPerson.clickToViewOrEditPersonData')"
              >
                {{ $t("sectionModalPerson.clickToViewOrEditPersonData") }}
              </a>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import ProfilePictureVue from "../../components/chat/ProfilePicture.vue";
export default {
  name: "ModalPerson",
  components: {
    RotateSquare,
    ProfilePictureVue
  },
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    nome: {
      type: String,
      default: ""
    },
      image: {
      type: String,
      default: ""
    },
    numero: {
      type: String,
      default: ""
    },
    evento: {
      type: String,
      default: ""
    },
    urlPerfil: {
      type: String,
      default: ""
    },
    enumTipoContato: {
      type: Number,
      default: ""
    },
  },
  data() {
    return {
      viewModel: {
        numeroTelefone: "",
        nome: "",
        id: "",
        image: "",
        urlPerfil: "",
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        ativo:true
      },
      loading: false,
      abrir: false
    };
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      
      this.Editar();
    },
    Editar() {
      this.loading = true;
      this.$http({
        url: "contato/editar",
        data: this.viewModel,
        method: "PUT"
      })
        .then(() => {
          this.loading = false;

          const contactChangedSuccessfully = this.$t(
            "infoMessages.contactChangedSuccessfully"
          );

          this.$notify({
            data: [contactChangedSuccessfully],
            type: "success",
            duration: 5000
          });
          this.abrir = false;
          this.$emit(this.evento, this.viewModel);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    AbrirModal() {
      this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId;
      this.viewModel.numeroTelefone = this.numero;
      this.viewModel.nome = this.nome;
      this.viewModel.id = this.contatoId;
      this.viewModel.urlPerfil = this.urlPerfil;
      this.viewModel.enumTipoContato = this.enumTipoContato;
      this.abrir = true;
    },
    InativarContato(){

    }
  }
};
</script>
<style  lang="scss">
    .contato_profile{
      display: flex;
      justify-content: center;

      .profile-picture{
          div{
            border: 1px solid rgb(0, 0, 0);
          }
      }
    }
</style>
